import { erc20Abi, formatUnits, getContract, type Address, type WalletClient } from "viem";
import { TOKEN_ADDRESSES, TOKEN_CONFIG, publicClients } from "@/config";
import { TOKEN_IDS } from "@/types";
import { mainnet } from "viem/chains";
import { erc4626VaultAbi } from "@/abi/erc4626.abi";

export interface StakingPosition {
    iUSDStakedBalance: string;
    rewardsEarned: string;
    apy: number;
}

const defaultStakingPosition: StakingPosition = {
    iUSDStakedBalance: "0.00",
    rewardsEarned: "0.00",
    apy: 0,
};

export const fetchStakingPosition = async (
    userAddress: Address,
    _walletClient?: WalletClient, // @deprecated not used
): Promise<StakingPosition> => {
    try {
        const sIUSDAddress: Address = TOKEN_ADDRESSES[mainnet.id][TOKEN_IDS.SIUSD];

        const siUsdBalance = await getContract({
            abi: erc20Abi,
            address: sIUSDAddress,
            client: {
                public: publicClients[mainnet.id],
            },
        }).read.balanceOf([userAddress]);

        // Convert sIUSD balance to iUSD
        const convertedBalance = await getContract({
            abi: erc4626VaultAbi,
            address: sIUSDAddress,
            client: {
                public: publicClients[mainnet.id],
            },
        }).read.convertToAssets([siUsdBalance]);

        // Rewards = sIUSD balance - converted iUSD balance
        const rewardBalance = convertedBalance - siUsdBalance;

        // Format for output
        const formattedConvertedBalance = formatUnits(convertedBalance, TOKEN_CONFIG[TOKEN_IDS.SIUSD].decimals);
        const formattedRewardBalance = formatUnits(rewardBalance, TOKEN_CONFIG[TOKEN_IDS.SIUSD].decimals);

        return {
            iUSDStakedBalance: formattedConvertedBalance,
            rewardsEarned: formattedRewardBalance,
            apy: 0,
        };
    } catch (error) {
        console.error("Error fetching staking position:", error);
        return defaultStakingPosition;
    }
};
